import styled, { css } from "styled-components";
import * as Flex from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Flex";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";

export const wrapper = styled(Flex.Row)``;

export const SpinImages = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    flex-direction: row;
    height: 100%;
    transition:
        opacity 0.3s,
        transform 0.5s;
    overflow: hidden;
    z-index: 1;
`;

export const SpinInterior = styled.div<{ hasOutsideBox?: boolean }>`
    position: relative;
    flex: 1;
    width: 100%;
    padding-top: 44.43%;
    overflow: hidden;
`;

export const SpinGallery = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
`;

export const SpinImage = styled.img<{
    opacity?: number;
    margin?: string | number;
}>`
    width: 100%;
    max-width: 100%;
    height: auto;
    pointer-events: none;
    user-select: none;
    transition:
        opacity 0.3s,
        margin-left 0.3s;
    z-index: 5;
    ${({ margin }) =>
        margin &&
        margin !== "" &&
        css`
            margin-left: ${margin};
        `};
    ${({ opacity }) =>
        opacity &&
        css`
            opacity: ${opacity};
        `};

    html[dir="rtl"] & {
        ${({ margin }) =>
            margin &&
            margin !== "" &&
            css`
                margin-left: 0;
                margin-right: ${margin};
            `};
    }
`;

export const SpinNavButtons = styled.div`
    display: none;
    position: relative;
    width: 100%;
    padding: 0 ${theme.space[3]}px;
    z-index: 1001;

    ${Button.Icon} {
        background-color: ${theme.colors.dark};
    }

    @media ${getBreakpoint("up", "md")} {
        display: block;
        top: 50%;
        bottom: auto;
        transform: translateY(-50%);
    }
`;

export const ButtonLeft = styled(Button.Icon)`
    position: absolute !important;
    left: ${theme.space[3]}px;

    html[dir="rtl"] & {
        left: auto;
        right: ${theme.space[3]}px;
    }
`;

export const ButtonRight = styled(Button.Icon)`
    position: absolute !important;
    right: ${theme.space[3]}px;

    html[dir="rtl"] & {
        left: ${theme.space[3]}px;
        right: auto;
    }
`;

export const SpinNav = styled.nav`
    display: block;
    position: absolute;
    bottom: 23px;
    left: 0;
    right: 0;
    text-align: center;
    z-index: 1000;
`;

export const SpinNavItem = styled.a<{ isActive?: boolean }>`
    display: inline-block;
    position: relative;
    width: 50px;
    height: 24px;
    margin-right: 15px;
    text-decoration: none;
    color: ${theme.colors.dark};
    outline: 0;
    cursor: pointer;
    &::after {
        position: absolute;
        top: 50%;
        left: 0;
        width: 100%;
        height: 2px;
        margin-top: -1px;
        content: "";
        ${({ isActive }) =>
            !isActive
                ? css`
                      background-color: rgba(255, 255, 255, 0.5);
                  `
                : css`
                      background-color: ${theme.colors.lightest};
                  `};
    }

    @media ${getBreakpoint("up", "md")} {
        width: 40px;
    }

    html[dir="rtl"] & {
        &::after {
            left: auto;
            right: 0;
        }
    }
`;
